import Typography from "@mui/material/Typography";
// #1805 — nextRide.scheduledTime is an FVD Access stamp (#1811), not a
// genuine instant, so it renders through the shared FVD_STAMP_TIMEZONE
// constant, not a local "America/Los_Angeles" literal or the show's real
// venueTimezone (that would be the #1805 3-hour regression #1811 headed off).
//
// #1814 AC3 -- the ride carries an optional `scheduledTimeZone` marker (foxbox
// composed the time in a configured venue zone, a genuine UTC instant); the
// stamp is read in that zone. No marker = the legacy FVD_STAMP_TIMEZONE read.
import { stampZoneOf } from "common-fe/venueTime";

function formatTime(iso, scheduledTimeZone) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? null
    : // #612 / #1805 — render the FVD stamp through FVD_STAMP_TIMEZONE.
      d.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
        timeZone: stampZoneOf(scheduledTimeZone),
      });
}

// Compact "next ride" table cell (#558): time · ring · class, truncated with an
// ellipsis (full value on hover via title). `nextRide` is the { scheduledTime,
// ring, className } summary from useNextRides, or null when the entity has no
// ride in the active show.
export default function NextRideCell({ nextRide, ringLabel = "Ring", emptyLabel = "—" }) {
  const bits = nextRide
    ? [
        formatTime(nextRide.scheduledTime, nextRide.scheduledTimeZone),
        nextRide.ring != null ? `${ringLabel} ${nextRide.ring}` : null,
        nextRide.className,
      ].filter(Boolean)
    : [];
  const text = bits.length ? bits.join(" · ") : emptyLabel;
  return (
    <Typography
      variant="body2"
      noWrap
      sx={{ maxWidth: 260 }}
      color={bits.length ? "text.primary" : "text.secondary"}
      title={text}
    >
      {text}
    </Typography>
  );
}
